import React, { useState } from 'react';
import './LyricsModal.css';

const API_BASE = process.env.REACT_APP_API_URL || '';

interface LyricsModalProps {
  artist: string;
  title: string;
  onClose: () => void;
  onInsert?: (lyrics: string) => void;
}

export const LyricsModal: React.FC<LyricsModalProps> = ({ artist, title, onClose, onInsert }) => {
  const [lyrics, setLyrics] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [searched, setSearched] = useState(false);

  const searchLyrics = async () => {
    setLoading(true);
    setError(null);
    setSearched(true);

    try {
      const response = await fetch(
        `${API_BASE}/api/lyrics?artist=${encodeURIComponent(artist)}&title=${encodeURIComponent(title)}`
      );
      
      if (response.ok) {
        const data = await response.json();
        setLyrics(data.lyrics);
      } else {
        setError('Songtekst niet gevonden. Probeer een andere zoekopdracht.');
      }
    } catch (err) {
      setError('Fout bij ophalen songtekst');
    } finally {
      setLoading(false);
    }
  };

  const handleInsert = () => {
    if (lyrics && onInsert) {
      onInsert(lyrics);
      onClose();
    }
  };

  const copyToClipboard = () => {
    if (lyrics) {
      navigator.clipboard.writeText(lyrics);
    }
  };

  return (
    <div className="lyrics-modal-overlay" onClick={onClose}>
      <div className="lyrics-modal" onClick={e => e.stopPropagation()}>
        <div className="lyrics-modal-header">
          <h3>🎤 Songtekst</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="lyrics-song-info">
          <strong>{title}</strong> — {artist}
        </div>

        {!searched ? (
          <div className="lyrics-search-prompt">
            <p>Klik op zoeken om de songtekst op te halen.</p>
            <button className="search-lyrics-btn" onClick={searchLyrics}>
              🔍 Zoek Songtekst
            </button>
          </div>
        ) : loading ? (
          <div className="lyrics-loading">
            <div className="spinner"></div>
            <p>Songtekst zoeken...</p>
          </div>
        ) : error ? (
          <div className="lyrics-error">
            <p>{error}</p>
            <button className="retry-btn" onClick={searchLyrics}>
              Opnieuw proberen
            </button>
          </div>
        ) : lyrics ? (
          <>
            <div className="lyrics-content">
              <pre>{lyrics}</pre>
            </div>
            <div className="lyrics-actions">
              <button className="copy-btn" onClick={copyToClipboard}>
                📋 Kopiëren
              </button>
              {onInsert && (
                <button className="insert-btn" onClick={handleInsert}>
                  ✅ Invoegen
                </button>
              )}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default LyricsModal;
